// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"669":"9b05c65c","734":"8d9f261c"}[chunkId] + ".chunk.css";
};